const API_URL = process.env.NEXT_PUBLIC_API_URL || ''

// Backend /api/market/sidebar endpoint

export interface SidebarQuote {
  symbol: string
  name: string
  value: number
  change: number
  changePercent: number
}

export interface SidebarMover {
  symbol: string
  name: string
  value: number
  changePercent: number
  volume: string
}

export interface SidebarMovers {
  active: SidebarMover[]
  gainers: SidebarMover[]
  losers: SidebarMover[]
}

export interface SidebarNews {
  id: string
  slug: string
  title: string
  source: string
  date: string
  url?: string
}

export interface SidebarData {
  indices: SidebarQuote[]
  forex: SidebarQuote[]
  commodities: SidebarQuote[]
  stocks: SidebarQuote[]
  movers: SidebarMovers
  trending: SidebarMover[]
  news: SidebarNews[]
  updatedAt: string
}

export async function fetchSidebarData(lang = 'tr'): Promise<SidebarData | null> {
  try {
    // U2 (Temmuz 2026 denetimi): bu veri artık layout'ta sunucu tarafında da çekiliyor
    // (ticker + son dakika şeridi SSR). Önbellek olmadan her sayfa isteği backend'e
    // ayrı bir çağrı yapardı; 30 sn anlık fiyat şeridi için yeterince taze.
    const res = await fetch(`${API_URL}/api/market/sidebar?lang=${lang}`, {
      next: { revalidate: 30 },
    })
    if (!res.ok) return null
    return res.json()
  } catch {
    return null
  }
}

// Period mapping: frontend Türkçe → backend
const periodMap: Record<string, string> = {
  '1G': '1g',
  '1H': '1h',
  '1A': '1a',
  '1Y': '1y',
  '5Y': '5y',
}

export async function fetchSidebarChart(symbol: string, period: string): Promise<number[]> {
  try {
    const p = periodMap[period] || period.toLowerCase()
    // Ana sayfa açılış grafiği artık sunucuda da çekiliyor (E2). "1A" gibi uzun
    // periyotlu seri yavaş değiştiği için 5 dk önbellek her istekte backend'e
    // gitmeyi önler; istemci tarafı kullanımı bundan etkilenmez.
    const res = await fetch(`${API_URL}/api/market/chart/${symbol}?period=${p}`, {
      next: { revalidate: 300 },
    })
    if (!res.ok) return []
    const data = await res.json()
    return (data.data || []).map((pt: { close: number }) => pt.close)
  } catch {
    return []
  }
}
